import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { SaleService } from '../services/sale.service';
import { Sale } from '../models/sale.model';

@Injectable({
  providedIn: 'root',
})
export class ArticleResolver implements Resolve<Sale[]> {
  // skipcq
  constructor(private _saleService: SaleService, private _loadingService: LoadingService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Sale[]> {
    if(this._saleService.sales.length > 0) {
      return of(this._saleService.sales);
    }
    const articleId = route.paramMap.get('articleId');
    const storeId = route.paramMap.get('storeId');
    const articleDate = route.paramMap.get('articleDate');
    this._loadingService.startLoading();
    return this._saleService.getInitialArticleById(articleId, storeId, articleDate).pipe(
      map((val) => {
        this._loadingService.stopLoading();
        return val;
      }),
      catchError((e) => {
        this._loadingService.stopLoading();
        console.log(e);
        
        return of(null);
      })
    );
  }
}
